module.exports = __webpack_public_path__ + "img/arrow-down-short-wide.dc35c195.svg";